"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyScoresByOwnerId = void 0;
const helpers_1 = require("../helpers");
exports.propertyScoresByOwnerId = (state = {}, action = {}) => {
    switch (action.type) {
        case 'PROPERTY_SCORES_GET_BY_OWNER_RECEIVE':
            const scores = action.payload.scores.map((s) => {
                const rounding = helpers_1.handleRounding(s.total_score);
                return Object.assign(Object.assign({}, s), { unrounded_total_score: rounding.unrounded_score, total_score: rounding.score });
            });
            return Object.assign(Object.assign({}, state), { [action.payload.id]: scores });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map